import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _memoize from "lodash/memoize";
import _debounce from "lodash/debounce";
import "core-js/modules/es6.string.starts-with.js";
/* eslint-disable no-console */
import React, { Component } from 'react';
import classnames from 'classnames';
import Typeahead from '@nerdwallet/react-typeahead';
import { Button, Type } from '@nerdwallet/currency';
import elementInteraction from '@nerdwallet/nw-client-lib/lib/tracking/element-interaction';
import formInteractionEvent from '@nerdwallet/nw-client-lib/lib/tracking/form-interaction-event';
import { fetchSuggestions } from "../lib/fetch";
import MagnifyingGlass from "../svg/magnifying-glass";
import styles from "./search-input.module.less";
var SearchInput = /*#__PURE__*/function (_Component) {
  _inherits(SearchInput, _Component);
  var _super = _createSuper(SearchInput);
  function SearchInput(props) {
    var _this;
    _classCallCheck(this, SearchInput);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "renderRow", function (row) {
      if (row.suggestion && row.suggestion.toLowerCase().startsWith(_this.state.value.toLowerCase())) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Type, {
          inline: true,
          bold: true,
          component: "div",
          className: classnames(styles['typeahead-result'])
        }, row.suggestion.substring(0, _this.state.value.length)), /*#__PURE__*/React.createElement(Type, {
          inline: true,
          className: classnames(styles['typeahead-result'])
        }, row.suggestion.substring(_this.state.value.length)));
      }
      return /*#__PURE__*/React.createElement(Type, {
        inline: true,
        className: classnames(styles['typeahead-result'])
      }, row.suggestion);
    });
    _this.state = {
      suggestionsList: [],
      value: props.value
    };
    _this.handleSearchInput = _this.handleSearchInput.bind(_assertThisInitialized(_this));
    _this.handleSearchEnter = _this.handleSearchEnter.bind(_assertThisInitialized(_this));
    _this.handleSuggestionClick = _this.handleSuggestionClick.bind(_assertThisInitialized(_this));
    _this.onSuggestionResponse = _this.onSuggestionResponse.bind(_assertThisInitialized(_this));
    _this.getSuggestions = _debounce(_this.getSuggestions, 200);
    _this.makeSuggestionRequest = _memoize(_this.makeSuggestionRequest);
    _this.onClearInput = _this.onClearInput.bind(_assertThisInitialized(_this));
    return _this;
  }

  // eslint-disable-next-line react/no-deprecated
  _createClass(SearchInput, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref) {
      var value = _ref.value;
      if (value !== this.props.value) {
        this.setState({
          value: value
        });
      }
    }
  }, {
    key: "handleSearchEnter",
    value: function handleSearchEnter(val) {
      this.props.onSearch(val);
      formInteractionEvent.onFormSubmit({
        formName: 'site-search-input',
        fieldValue: val
      });
    }
  }, {
    key: "handleSearchInput",
    value: function handleSearchInput(val) {
      this.setState({
        value: val
      });
      if (!val) return;
      this.getSuggestions({
        searchTerm: val
      });
    }
  }, {
    key: "handleSuggestionClick",
    value: function handleSuggestionClick(_ref2, index) {
      var suggestion = _ref2.suggestion;
      this.props.onSearch(suggestion, {
        suggestion: true,
        index: index
      });
      elementInteraction({
        elementName: 'site-search-input-suggestion',
        interactionType: 'CLICK',
        elementPosition: index,
        elementContent: suggestion
      });
    }
  }, {
    key: "onClearInput",
    value: function onClearInput() {
      this.setState({
        value: ''
      });
    }
  }, {
    key: "onSuggestionResponse",
    value: function onSuggestionResponse(_ref3) {
      var _data$suggest, _data$suggest2;
      var data = _ref3.data;
      var query = data === null || data === void 0 ? void 0 : (_data$suggest = data.suggest) === null || _data$suggest === void 0 ? void 0 : _data$suggest.query;
      var suggestionsList = data === null || data === void 0 ? void 0 : (_data$suggest2 = data.suggest) === null || _data$suggest2 === void 0 ? void 0 : _data$suggest2.suggestions;
      if (query !== this.state.value) return;
      this.setState({
        suggestionsList: suggestionsList
      });
    }
  }, {
    key: "getSuggestions",
    value: function getSuggestions(_ref4) {
      var searchTerm = _ref4.searchTerm;
      this.makeSuggestionRequest(searchTerm).then(this.onSuggestionResponse).catch(console.log);
    }
  }, {
    key: "getTypeaheadProps",
    value: function getTypeaheadProps() {
      var _this2 = this;
      var _this$props = this.props,
        inputProps = _this$props.inputProps,
        id = _this$props.id;
      inputProps.id = id || 'searchInput';
      inputProps.value = this.state.value;
      return {
        results: this.state.suggestionsList,
        inputProps: inputProps,
        renderRow: this.renderRow,
        typeaheadHandler: this.handleSearchInput,
        primaryKey: 'id',
        autoFocus: this.props.autoFocus,
        placeholder: this.props.placeholder,
        onClick: this.handleSuggestionClick,
        onEnter: function onEnter(e, val) {
          _this2.handleSearchEnter(val);
        },
        hideResultsNoInput: true,
        showClearInput: this.props.showClearInput && !!this.state.value || false,
        inputClearColor: this.props.inputClearColor || 'neutral-darker',
        onClearInput: this.onClearInput
      };
    }
  }, {
    key: "makeSuggestionRequest",
    value: function makeSuggestionRequest(searchTerm) {
      var _this$props2 = this.props,
        nwApiSdk = _this$props2.nwApiSdk,
        searchServicesBaseUri = _this$props2.searchServicesBaseUri;

      // return early if assets needed for suggestion api call aren't provided
      if (!nwApiSdk) return;
      if (!searchServicesBaseUri) return;

      // eslint-disable-next-line consistent-return
      return fetchSuggestions({
        searchTerm: searchTerm,
        nwApiSdk: nwApiSdk,
        searchServicesBaseUri: searchServicesBaseUri
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      return /*#__PURE__*/React.createElement("div", {
        className: classnames(styles['search-input-container'])
      }, /*#__PURE__*/React.createElement("div", {
        className: classnames(styles['search-input'], this.props.className)
      }, /*#__PURE__*/React.createElement(MagnifyingGlass, {
        className: "search-icon"
      }), /*#__PURE__*/React.createElement(Typeahead, this.getTypeaheadProps())), /*#__PURE__*/React.createElement(Button, {
        primary: true,
        onClick: function onClick() {
          return _this3.props.onSearch(_this3.state.value);
        },
        className: classnames(styles['search-button'])
      }, "SEARCH"));
    }
  }]);
  return SearchInput;
}(Component);
_defineProperty(SearchInput, "displayName", 'SearchInput');
_defineProperty(SearchInput, "defaultProps", {
  autoFocus: true,
  onSearch: function onSearch() {},
  inputProps: {},
  placeholder: 'Try something like "Best savings account?"'
});
export { SearchInput as default };